import { renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'
import _imports_1 from '@/app/ui/assets/svg/logo-genesis-with-text.svg'


const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "\n        justify-center\n        items-center\n        py-6\n        flex\n        overflow-hidden\n        fixed\n        inset-0\n        z-40\n        outline-none\n        focus:outline-none\n      " }
const _hoisted_3 = {
  style: {"width":"510px"},
  class: 
          ` relative max-h-full flex flex-col justify-between bg-white rounded`
        
}
const _hoisted_4 = { class: "p-4 pb-0 rounded-t" }
const _hoisted_5 = { class: "inline-flex w-full justify-end" }
const _hoisted_6 = { class: "flex flex-col items-center mt-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-32 xxl:w-36",
  alt: "logo genesis"
}, null, -1)
const _hoisted_8 = { class: "font-semibold text-24px mt-4 text-black-lp-100" }
const _hoisted_9 = {
  class: "overflow-auto px-10 py-4 content",
  style: {"max-height":"40rem"}
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "opacity-75 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                src: _imports_0,
                class: "w-6 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args))),
                alt: "x"
              })
            ]),
            _createVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.title), 1)
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _renderSlot(_ctx.$slots, "content")
          ])
        ])
      ])
    ]),
    _hoisted_10
  ]))
}